/// <reference types="vite/client" />
import { z } from "zod";

const envVariablesSchema = z.object({
  VITE_URL_SCHEME: z.string(),
  VITE_WEB_DOMAIN: z.string(),
  VITE_WEB_DOMAIN_COOKIE: z.string(),
  VITE_SERVER_DOMAIN: z.string(),
  VITE_CLIENT_ERROR_SLACK_API_URL: z.string(),
  VITE_USDA_API_KEY: z.string(),
  VITE_WEB_SCHEMA_VERSION: z.string(),
  VITE_GAINSIGHT_PX_KEY_TAG: z.string(),
  VITE_COMMIT_HASH: z.string(),
  VITE_DATADOG_ENV: z.string(),
  VITE_DATADOG_RUM_ENABLED: z.string(),
  VITE_DATADOG_SITE: z.string(),
  VITE_DATADOG_CLIENT_TOKEN: z.string(),
  VITE_DATADOG_APPLICATION_ID: z.string(),
  VITE_STREAM_CHAT_API_KEY: z.string(),
  VITE_TW_OKTA_DOMAIN: z.string(),
  VITE_TW_OKTA_ISSUER: z.string(),
  VITE_TW_OKTA_WEB_CLIENT_ID: z.string(),
  VITE_ENV_TYPE: z.string(),
  VITE_LD_FLAGS_CLIENT_ID: z.string(),
  VITE_CUSTOMER_IO_SDK_KEY: z.string(),
  VITE_TW_MFE_ENV: z.enum(['staging', 'production', 'staging-gov', 'production-gov']),
  VITE_REGION: z.enum(['ap', 'eu', 'us']),
});

export const environment = envVariablesSchema.parse(import.meta.env);
